module.exports = __webpack_public_path__ + "img/CC-LogoMark.2291f2d6.png";